<template>
  <div>
    <v-dialog scrollable v-model="show_dialog" width="700">
      <v-card>
        <v-card-title class="primary_2 text-h6 white--text py-2">
          Update Status
          <v-spacer></v-spacer>
          <v-btn fab small text @click="closeDialog()">
            <v-icon large color="white">
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-2">
          <v-form ref="update_status">
            <v-row class="ma-0">
              <v-col cols="6">
                <p class="field-title">
                  Name
                </p>
                <p class="field-content">
                  {{ this.customer_details.name }}
                </p>
              </v-col>
              <v-col cols="6">
                <p class="field-title">
                  Mobile
                </p>
                <p class="field-content">
                  {{ this.customer_details.mobile }}
                </p>
              </v-col>
              <v-col cols="6">
                <p class="field-title">
                  Email
                </p>
                <p class="field-content">
                  {{ this.customer_details.email }}
                </p>
              </v-col>
              <v-col cols="6">
                <p class="field-title">
                  Current Status
                </p>
                <p class="field-content">
                  {{ formatString(this.current_status) | stageLabel }}
                </p>
              </v-col>
              <v-col cols="12" class="py-0">
                <p class="field-title">
                  Status
                </p>
                <v-select
                  :items="status_list"
                  item-value="param"
                  item-text="title"
                  placeholder="Select"
                  v-model="loan_status"
                  outlined
                  clearable
                  dense
                  required
                >
                </v-select>
              </v-col>
              <v-col cols="9" class="pt-0" v-if="loan_status == 'rejected'">
                <v-form ref="add_rejection_reason_field">
                  <v-text-field
                    class="add-reason-field"
                    v-model="new_rejection_reason"
                    outlined
                    hide-details
                    :rules="$rules.REQUIRED_FIELD"
                    label="New Rejection Reason"
                    dense
                    v-if="show_add_rejection_reason"
                    placeholder="Enter new rejection reason"
                  >
                  </v-text-field>
                </v-form>
              </v-col>
              <v-col cols="3" class="pt-0" v-if="loan_status == 'rejected'">
                <div class="btns-wrapper">
                  <v-btn
                    color="secondary_2"
                    rounded
                    small
                    text
                    outlined
                    class="mx-1 mb-3"
                    v-if="!show_add_rejection_reason"
                    @click="show_add_rejection_reason = true"
                  >
                    + Add Reason
                  </v-btn>
                  <v-btn
                    color="secondary_2"
                    rounded
                    small
                    class="mx-1 white--text"
                    v-if="show_add_rejection_reason"
                    @click="saveReason()"
                    :loading="save_btn_loader"
                    depressed
                    :disabled="save_btn_loader"
                  >
                    Save
                  </v-btn>
                  <v-btn
                    color="secondary_2"
                    fab
                    x-small
                    text
                    outlined
                    class="mx-1 pa-0"
                    :loading="save_btn_loader"
                    :disabled="save_btn_loader"
                    v-if="show_add_rejection_reason"
                    @click="hideAddRejectionReason()"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" class="py-0" v-if="loan_status == 'rejected'">
                <p class="field-title">
                  Rejection Reason
                </p>
                <v-combobox
                  v-model="reason"
                  :items="reason_list"
                  :loading="reason_loading"
                  :search-input.sync="reason_search"
                  clearable
                  dense
                  required
                  :rules="$rules.REQURIED_FILED"
                  item-text="rejection_reason"
                  item-value="rejection_reason"
                  outlined
                  placeholder="Select reason"
                  @focus="getReasonList()"
                >
                </v-combobox>
              </v-col>
              <v-col cols="6" class="py-0" v-if="loan_status == 'disbursed'">
                <p class="field-title">
                  Disbursed Loan Amount
                </p>
                <p class="">
                  <v-text-field
                    v-model="disbursal_amount"
                    outlined
                    placeholder="Enter Amount"
                    :rules="$rules.REQURIED_FILED"
                    type="number"
                    dense
                  >
                  </v-text-field>
                </p>
              </v-col>
              <v-col cols="6" class="py-0" v-if="loan_status == 'disbursed'">
                <p class="field-title">
                  Disbursed Tenure
                </p>
                <p class="">
                  <v-text-field
                    v-model="tenure"
                    outlined
                    type="number"
                    placeholder="Enter Tenure"
                    dense
                    suffix="Months"
                  >
                  </v-text-field>
                </p>
              </v-col>
              <v-col cols="6" class="py-0" v-if="loan_status == 'disbursed'">
                <p class="field-title">
                  Disbursed Date
                </p>
                <p class="">
                  <v-menu
                    v-model="disbursal_date_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    min-width="290px"
                    offset-y
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="disbursal_date"
                        v-on="on"
                        placeholder="Select Date"
                        dense
                        outlined
                        :rules="$rules.REQURIED_FILED"
                        readonly
                      >
                        <template slot="append">
                          <v-icon
                            v-if="disbursal_date"
                            @click="disbursal_date = null"
                            >mdi-close
                          </v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="disbursal_date">
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        text
                        @click="disbursal_date_menu = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="primary"
                        text
                        @click="disbursal_date_menu = false"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                </p>
              </v-col>
              <v-col cols="12" class="py-0">
                <p class="field-title">
                  Internal Comments
                </p>
                <v-text-field
                  v-model="internal_comments"
                  outlined
                  placeholder="Internal Comment"
                  type="text"
                  dense
                  :rules="loan_status ? $rules.REQURIED_FILED : []"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="d-flex align-center justify-end pb-4">
          <v-btn
            color="success"
            rounded
            class="mx-1 white--text px-4 font-weight-bold"
            @click="updateStatus()"
            :loading="update_btn_loader"
            :disabled="update_btn_loader"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show_dialog: false,
      status_list: [],
      loan_status: "",
      disbursal_amount: "",
      disbursal_date: null,
      disbursal_date_menu: false,
      tenure: "",
      internal_comments: "",
      customer_details: {},

      reason: "",
      reason_list: [],
      reason_loading: false,
      reason_search: "",
      current_status: null,
      update_btn_loader: false,

      new_rejection_reason: "",
      show_add_rejection_reason: false,
      save_btn_loader: false,
    };
  },
  methods: {
    async openUpdateStatus(value, current_status, list) {
      this.show_dialog = true;
      // tabs.filter(tab => tab.title !== "All");
      // `param` is the server's value and is sent back untouched; only the
      // `title` that the operator reads is cleaned up, dropping the trailing
      // "By NBFC" now that the panel no longer surfaces lenders.
      this.status_list = list
        .filter((tab) => tab.title !== "All" && tab.title !== "Pending By NBFC")
        .map((tab) => ({
          ...tab,
          title: String(tab.title).replace(/\s*By NBFC$/i, "").trim(),
        }));
      this.customer_details = value;
      this.internal_comments = value.comment;
      this.current_status = current_status;
    },
    formatString(str) {
      if (str) {
        return str
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      }
    },
    saveReason() {
      if (this.new_rejection_reason) {
        const self = this;
        self.save_btn_loader = true;

        let form = {
          rejection_reason: this.new_rejection_reason,
        };

        const successHandler = () => {
          self.save_btn_loader = false;
          self.show_add_rejection_reason = false;
          this.new_rejection_reason = "";
          self.getReasonList();
        };
        const finallyHandler = () => {
          self.save_btn_loader = false;
        };
        self.POST_request(
          self,
          self.$urls.GET_CREATE_NBFC_REJECTION_REASON,
          form,
          successHandler,
          null,
          null,
          finallyHandler
        );
      } else {
        this.showSnakeBar("error", "Please enter a new reason before saving");
      }
    },
    hideAddRejectionReason() {
      this.new_rejection_reason = "";
      this.show_add_rejection_reason = false;
    },
    getReasonList() {
      const self = this;
      self.reason_loading = true;
      let params = {};
      console.log(params);
      const successHandler = (response) => {
        self.reason_list = response.data.result;
      };
      const finallyHandler = () => {
        self.reason_loading = false;
      };

      self.request_GET(
        self,
        self.$urls.GET_CREATE_NBFC_REJECTION_REASON,
        params,
        successHandler,
        null,
        null,
        finallyHandler
      );
    },
    closeDialog() {
      this.show_dialog = false;
      this.$refs.update_status.reset();
      this.rejection_list = [];
    },
    updateStatus() {
      if (this.$refs.update_status.validate()) {
        const self = this;
        self.update_btn_loader = true;

        let form = {};
        if (self.loan_status) {
          form.loan_status = self.loan_status;
        }
        if (self.internal_comments) {
          form.internal_comment = self.internal_comments;
        }
        if (self.disbursal_amount) {
          form.sanctioned_amount = self.disbursal_amount;
        }
        if (self.disbursal_date) {
          form.disbursal_date = self.disbursal_date;
        }
        if (self.tenure) {
          form.tenure = self.tenure;
        }
        if (self.reason) {
          form.rejection_reason = self.reason.rejection_reason;
        }

        const successHandler = () => {
          this.$emit("update");
          self.closeDialog();
        };
        const finallyHandler = () => {
          self.update_btn_loader = false;
        };
        self.POST_request(
          self,
          self.$urls.MODIFY_PRECHECK_STATUS + `${this.customer_details.id}/`,
          form,
          successHandler,
          null,
          null,
          finallyHandler
        );
      }
    },
  },
};
</script>
<style scoped>
.chip-text {
  color: #000 !important;
  padding-right: 5px;
}
</style>
